'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Block = function (_Phaser$Sprite) {
  _inherits(Block, _Phaser$Sprite);

  function Block(game, x, y) {
    _classCallCheck(this, Block);

    var _this = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, game, x, y, 'block'));

    _this.game.physics.enable(_this);
    _this.body.collideWorldBounds = true;
    _this.body.allowGravity = false;
    _this.body.immovable = true;
    _this.body.velocity.x = 100;
    return _this;
  }

  _createClass(Block, [{
    key: 'update',
    value: function update() {
      // check against walls and reverse direction if necessary
      if (this.body.touching.right || this.body.blocked.right) {
        this.body.velocity.x = -100; // turn left
      } else if (this.body.touching.left || this.body.blocked.left) {
        this.body.velocity.x = 100; // turn right
      }
    }
  }]);

  return Block;
}(_phaser2.default.Sprite);

exports.default = Block;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Block.js
// module id = 342
// module chunks = 0